export const ENDPOINTS = {
  BASE_URL: process.env.REACT_APP_API_URL,
  // ADMIN APIS
  ADMIN_USER: '/admingetuser',
  ADMIN_CONFIRM: '/adminconfirmuser',
  ADMIN_UPDATE_EMAIL: '/v2/admin/updateEmail',
  SEARCH_USER: '/v2/search',
  ACCOUNT: '/accounts/serviceAddress',
  UPDATE_MAILING_ADDRESS: '/v2/admin/mailingAddress',
  UPDATE_INFO: '/admin/update',
  ALL_LINKED_ACCOUNTS: '/v2/admin/linkedAccounts',
  UPDATE_COGNITO_ATTRIBUTE: '/v2/updateCognitoAttribute',

  ASSETS: '/assets',
  CAMPAIGNS: '/campaign',
  CAMPAIGN_LOGS: '/campaignLogs',
  SETTINGS: '/settings',

  // Invoice Cloud APIS
  IC_ACCOUNTS: '/invoiceCloud',
  IC_STATUS: '/invoiceCloud/status',
  IC_CREATE_ACCOUNT: '/invoiceCloud/create',
  IC_REGISTER_ACCOUNT: '/invoiceCloud/register',
  IC_UNREGISTER_ACCOUNT: '/invoiceCloud/unregister',
  IC_PASSWORD: '/invoiceCloud/password',
  IC_LINK_ACCOUNTS: '/invoiceCloud/link',
  IC_UNLINK_ACCOUNTS: '/invoiceCloud/unlink',
  IC_SYNC_PASSWORD: '/invoiceCloud/password/sync',
  IC_LINK_ACCOUNT: '/invoiceCloud/link',
  LINK_ACCOUNT: '/invoiceCloud/link',
  IC_UPDATE_EMAIL: '/invoiceCloud/updateEmail',

  UNREGISTER_ACCOUNT: '/v2/unregister',

  // CCS APIS
  VERIFY_ACCOUNT: '/verifyAccount',
  VERIFY_ACCOUNT_TO_LINK: '/v2/verifyAccountToLink',
  UPDATE_EMAIL_AFTER_LINK: '/v2/updateEmailAfterLink'
}
